<template>
    <div id="contenedor">
        <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-card class="table" elevation="4">
                <v-toolbar flat elevation="4">
                    <v-card class="icon">
                        <v-icon style="margin-left:30px; margin-top:25px" color="white" x-large="">mdi-responsive</v-icon>
                    </v-card>
                    <div class="usuario">APLICACIONES</div>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px" persistent>
                        <template v-slot:activator="{ on }">
                            <v-btn dark class="botonplus" v-on="on"><v-icon color="white">mdi-plus-thick</v-icon></v-btn>
                        </template>
                        <v-card style="display: flex; flex-direction: column; max-height: 90vh;">
                            <v-card-title class="nav" style="flex-shrink: 0;">
                                <span class="headline" style="color:whitesmoke"><v-icon color="white">mdi-account</v-icon> {{ formTitle }}</span>
                            </v-card-title>
                            <!-- componente del modal para agregar y actualizar -->
                            <v-card-text style="flex: 1 1 auto; overflow-y: auto; min-height: 0;">
                                <v-container grid-list-md>
                                  <v-layout wrap>
                                      <v-flex xs12 sm12 md12>
                                          <v-text-field v-model="editedItem.nombreApp" label="Nombre" mask="#############"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm12 md12>
                                          <v-text-field v-model="editedItem.img" label="Nombre Imagen"></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm12 md12>
                                          <v-text-field v-model="editedItem.ruta" label="URL"></v-text-field>
                                      </v-flex>
                                  </v-layout>
                                </v-container>
                            </v-card-text>
                            <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                            <v-card-actions style="flex-shrink: 0;">
                                <v-spacer></v-spacer>
                                <v-btn color="#1D3C7F"  dark @click="close">Cancelar</v-btn>
                                <v-btn
                                color="#1D3C7F"
                                dark
                                @click="save"
                                :disabled="!editedItem.img || !editedItem.nombreApp ||  !editedItem.ruta "
                                >Guardar</v-btn>
                            </v-card-actions>
                        <!-- <pre>{{editedItem}}</pre>  -->
                        </v-card>
                    </v-dialog>
                </v-toolbar> 
                <br>
                <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar Aplicación"
                class="text-field"
                single-line
                color="#111c3d"
                ></v-text-field>
                <br>
                <v-data-table 
                :headers="headers" 
                :items="apps" 
                :search="search"
                style=" border: 2px solid #111c3d;"
                class="elevation-3"
                >
                <!-- tabla donde se pintan los datos obtenidos del arreglo -->
                <template v-slot:item.action="{ item }">
                    <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                    >
                    mdi-pencil
                    </v-icon>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined>No se encontro su busqueda</v-alert>
                </template>
                </v-data-table>
                <!-- alertas de las acciones que se hacen -->
                <v-snackbar
                v-model="snackbar"
                :bottom="y === 'bottom'"
                :left="x === 'left'"
                :multi-line="mode === 'multi-line'"
                :right="x === 'right'"
                :timeout="timeout"
                :top="y === 'top'"
                :vertical="mode === 'vertical'"
                color="#294697"
                style="color:white"
                >
                {{ text }}
                <v-btn color="#294697" depressed  dark @click="snackbar = false">Cerrar</v-btn>
                </v-snackbar>
              </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      apps: [],
      rules: {
         required: value => !!value || 'Required.',
         counter: value => value.length <= 20 || 'Maximo 20 characteres',
         email: value => {
           const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
           return pattern.test(value) || 'Invalido e-mail.'
         }
       },
      dialog: false,
      headers: [
        {
          text: "Aplicación",
          align: "left",
          value: "nombreApp",
          align: "center",
          class: "column"
        },
        {
          text: "URL",
          value: "ruta",
          align: "center",
          class: "column"
        },
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          align: "center",
          class: "column"
        },
      ],
      defaultItem: {
        id: "",
        nombreApp: "",
        img:"",
        ruta:""
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        nombreApp: "",
        img:"",
        ruta:""
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva Aplicacion" : "Editar Aplicacion";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  mounted() {
    this.obtenerApps();
  },

  methods: {

// Metodo para obtener las aplicaciones
     obtenerApps() {
      axios.get(`${env.endpoint}user/apps`).then(res => (this.apps = res.data));
    }, 

/**
 * Metodo para agregar fila de la tabla en la modal
 */
    editItem(item) {
      this.editedIndex = this.apps.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
 
/**
 * Metodo para cerrar la modal
 */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

/**
 * Metodo para guardar y actualizar
 */
    save() {
      if (this.editedIndex > -1) {
        // obtiene los datos del arreglo para poder actualizar el usuario en el modal
        const app = JSON.stringify({
          id: this.editedItem.id,
          nombre: this.editedItem.nombreApp,
          img:this.editedItem.img,
          ruta:this.editedItem.ruta
        });
        
        // se seta los datos obtenidos del arreglo par modificarlo
        axios
          .get(`${env.endpoint}user/modificar_app?app=${app}`)
          .then(res => {
            if (res.data.mensaje === "app actualizada") {
              (this.snackbar = true),
                (this.text = "Aplicación actualizada satisfactoriamente");
            } else if (res.data.mensaje === "error en la actualizacion") {
              (this.snackbar = true), (this.text = "Error en la actualización");
            }
            this.obtenerApps();
          });
      } else {
        // obtiene los datos del arreglo para despues setearlos en una variable nuevoUsuario y pasarselo al metodo
        const nuevaAplicacion = JSON.stringify({
          nombre: this.editedItem.nombreApp,
          img:this.editedItem.img,
          ruta:this.editedItem.ruta
        });        
        // se crea el usuario
        axios
          .get(`${env.endpoint}user/create_app?app=${nuevaAplicacion}`)
          .then(res => {
            if (res.data.mensaje === "app registrado") {
              (this.snackbar = true),
                (this.text = "App registrada satisfactoriamente");
            } else if (res.data.mensaje === "error en el registro") {
              (this.snackbar = true), (this.text = "Error al registrar");
            } else if (res.data.mensaje === "error app existe") {
              (this.snackbar = true),
                (this.text = "La app ya existe en la plataforma");
            }
            // console.log(nuevoUsuario);
            this.obtenerApps();
          });
        }
      this.close();
      this.obtenerApps();
    }
  }
};
</script>